import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { OriginsOfConsciousness } from './pages/OriginsOfConsciousness';
export function AppRouter() {
  return <BrowserRouter data-id="element-1" data-mp="stsjgtfn950o">
      <Routes data-id="element-2" data-mp="ss7qv9cw3w5g">
        <Route path="/" element={<App data-id="element-4" data-mp="sr6b4rkxilhe" />} data-id="element-3" data-mp="ssqynx8tt45r" />
        <Route path="/projects/origins-of-consciousness" element={<OriginsOfConsciousness data-id="element-6" data-mp="ws84wsw2u5bz" />} data-id="element-5" data-mp="wucf1skkk0kp" />
      </Routes>
    </BrowserRouter>;
}